import Cookies from 'js-cookie';

// common
import { AUTHENTICATION_TOKEN } from 'common/constants';
import useGeneralHook from 'common/hook/useGeneralHook';
import { logoutFnc } from '@redux/authReducer';
import { apiClient } from 'api/apiClient';

const useService = () => {
  const { dispatch } = useGeneralHook();
  if (!Cookies.get(AUTHENTICATION_TOKEN)) {
    dispatch(logoutFnc());
  }
  return apiClient();
};
export default useService;
